import api from '../api/installations'

const state = {
  installationsList: [],
  installationDetails: {},
  error: null
}

const getters = {
  installationsList: state => state.installationsList,
  installationDetails: state => state.installationDetails
}

const actions = {
  getInstalls({ commit }) {
    return new Promise((resolve, reject) => {
      api
        .fetchInstallations()
        .then(response => {
          commit('SET_INSTALLS', response.data)
          resolve()
        })
        .catch(error => {
          commit('SET_ERROR', error)
          reject(error)
        })
    })
  },
  getRecord({ commit }, id) {
    return new Promise((resolve, reject) => {
      api
        .fetchInstallationDetails(id)
        .then(response => {
          commit('SET_INSTALLATION_DETAILS', response.data)
          resolve(response.data)
        })
        .catch(error => {
          commit('SET_ERROR', error)
          reject(error)
        })
    })
  }
}

const mutations = {
  SET_INSTALLS(state, installs) {
    state.installationsList = installs
  },
  SET_INSTALLATION_DETAILS(state, installation) {
    state.installationDetails = installation
  },
  SET_ERROR(state, error) {
    state.error = error
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
